import { createElement } from "react";
import type { ColumnsType } from "antd/es/table/interface";
import { buildColumns } from "@/views/Data/TrialIssues/utils";
import SeverityCell from "./SeverityCell";
import {
  BREACH_COLUMN_ORDER,
  COLUMN_WIDTHS,
  FIXED_COLUMNS,
  HIDDEN_COLUMNS,
  SEARCHABLE_COLUMNS,
  TITLE_MAPPING,
  type BreachTableRow,
} from "./utils";

export const createBreachColumns = (
  rows: BreachTableRow[],
): ColumnsType<BreachTableRow> => {
  return buildColumns({
    rows,
    columnOrder: BREACH_COLUMN_ORDER,
    titleMapping: TITLE_MAPPING,
    columnWidths: COLUMN_WIDTHS,
    searchableColumns: SEARCHABLE_COLUMNS,
    fixedColumns: FIXED_COLUMNS,
    hiddenColumns: HIDDEN_COLUMNS,
    customRender: (header, text) => {
      if (header === "severity") {
        return createElement(SeverityCell, {
          value: text as BreachTableRow[string],
        });
      }

      return undefined;
    },
  }) as ColumnsType<BreachTableRow>;
};
